import { ILinkContent } from './or-navbar.types';

export interface IGroupedLinkContent {
  links: {
    title: string;
    link: ILinkContent[];
  };
}

export interface IGroupedLinks {
  withTitle: IGroupedLinkContent[];
  withoutTitle: IGroupedLinkContent[];
}

export function groupLinksByTitle(items: IGroupedLinkContent[]): IGroupedLinks {
  return items.reduce<IGroupedLinks>(
    (acc, item) => {
      if (item.links.title) {
        acc.withTitle.push(item);
      } else {
        acc.withoutTitle.push(item);
      }
      return acc;
    },
    { withTitle: [], withoutTitle: [] },
  );
}
